export const SERVICES_LETTER_PAGES_ORDER_FOR_PERMISSIONS: string[] = [
  'service_letter',
  'service_subject',
  'service_target_audience',
  'place',
  'activity_type',
  'service',
  'public_agent_module_permission',
  'group_module_permission',
]
